export default __webpack_public_path__ + "static/media/nft3.e50f39a1.jpg";